import type { VoiceCallSession } from '../../../types/voice-call'

/**
 * Whether a 1:1 call offers Transfer / Add person. A telehealth session call
 * stays exactly between the session's provider and member (the server refuses
 * both too).
 */
export function allowsExtraParties(session: Pick<VoiceCallSession, 'isGroup' | 'sessionUuid'>): boolean {
  return !session.isGroup && !session.sessionUuid
}
